module.exports = __webpack_public_path__ + "img/e58f36a49d7b8213bfa6f3b08d55beee.e58f36a4.png";